// src/utils/assertion.ts
function isNull(value) {
  return value == null;
}
function isUndefined(value) {
  return typeof value === "undefined" || value === void 0;
}
function isDefined(value) {
  return typeof value !== "undefined" && value !== void 0;
}
function isNil(value) {
  return isNull(value) || isUndefined(value);
}
function isNilOrEmpty(value) {
  return isNil(value) || value === "";
}
function isString(value) {
  return Object.prototype.toString.call(value) === "[object String]";
}
function isNumber(value) {
  return typeof value === "number";
}
function isArray(value) {
  return Array.isArray(value);
}
function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}
function isFunction(value) {
  return typeof value === "function";
}
function isObject(value) {
  return typeof value === "object" && !Array.isArray(value) && value != null;
}
function isPlainObject(value) {
  if (Object.prototype.toString.call(value) !== "[object Object]") {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.prototype;
}
function isPromise(value) {
  return !isNil(value) && !isNil(value.then);
}

export { isArray, isDefined, isEmptyArray, isFunction, isNil, isNilOrEmpty, isNull, isNumber, isObject, isPlainObject, isPromise, isString, isUndefined };
